import { HYDRATE } from 'next-redux-wrapper';
import { THydrateAction } from '~/src/store';
import { ISlot } from '~/src/api/profile/constructor/info';

export const FETCH_CONSTRUCTOR_INFO = 'FETCH_CONSTRUCTOR_INFO';
export const SET_CONSTRUCTOR_INFO = 'SET_CONSTRUCTOR_INFO';
export const ERROR_CONSTRUCTOR_INFO = 'ERROR_CONSTRUCTOR_INFO';
export const CHANGE_CONSTRUCTOR_SLOT = 'CHANGE_CONSTRUCTOR_SLOT';

export interface IConstructorState {
    isFetching: boolean,
    fetchError: string,
    slots: ISlot[],
    cntFreePlaces: number,
}

export const initialState:IConstructorState = {
    isFetching: false,
    fetchError: '',
    slots: [],
    cntFreePlaces: 0,
};

export type TActions = {
    type:
        typeof FETCH_CONSTRUCTOR_INFO |
        typeof SET_CONSTRUCTOR_INFO |
        typeof ERROR_CONSTRUCTOR_INFO |
        typeof CHANGE_CONSTRUCTOR_SLOT,
    payload: Partial<IConstructorState>,
};

export default (state = initialState, action: TActions | THydrateAction): IConstructorState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.constructor };
        case FETCH_CONSTRUCTOR_INFO: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case SET_CONSTRUCTOR_INFO: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case ERROR_CONSTRUCTOR_INFO: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case CHANGE_CONSTRUCTOR_SLOT: {
            return {
                ...state,
                ...action.payload,
            };
        }

        default: return state;
    }
};
